module["exports"] = [
  0
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/address/postcode.js
// module id = 1148
// module chunks = 0